/**
 * @generated SignedSource<<b387d58755674457ae4f39adf063ec37>>
 * @relayHash 4d36c161a002817ebf0a774bd870c3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e

import type { ConcreteRequest } from 'relay-runtime';
export type MainLayoutQuery$variables = {
  spaceKey: string;
};
export type MainLayoutQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type MainLayoutQuery = {
  response: MainLayoutQuery$data;
  variables: MainLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "LookAndFeel",
        "kind": "LinkedField",
        "name": "lookAndFeel",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentLookAndFeel",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "concreteType": "ScreenLookAndFeel",
                "kind": "LinkedField",
                "name": "screen",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "background"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundColor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundImage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundPosition"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundSize"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundRepeat"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundOrigin"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundClip"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundAttachment"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "backgroundBlendMode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MainLayoutQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MainLayoutQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4d36c161a002817ebf0a774bd870c3f0",
    "id": "e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e",
    "metadata": {},
    "name": "MainLayoutQuery",
    "operationKind": "query",
    "text": "query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id,lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode}}}}}"
  }
};
})();

(node as any).hash = "de3e636b8d3cf59cd103bdc7552ea849";

export default node;
